import produce from 'immer'

const initialState = {
  // the single pending conflict shown in the fact-conflict modal, or null when
  // there is none. Shape: { pairs: [{ existing, added }], pendingAction }.
  pending: null,
}

const factConflict = produce((draft = initialState, action) => {
  switch (action.type) {
    case 'SHOW_FACT_CONFLICT':
      draft.pending = action.payload
      return draft
    case 'CLEAR_FACT_CONFLICT':
      draft.pending = null
      return draft
    default:
      return draft
  }
})

export default factConflict
